'use client'

import { motion } from 'framer-motion'
import { HTMLMotionProps } from 'framer-motion'

export const MotionDiv = motion.div
export const MotionSection = motion.section
export const MotionH1 = motion.h1
export const MotionP = motion.p
export const MotionSpan = motion.span

export interface MotionDivProps extends HTMLMotionProps<"div"> {
    className?: string;
    children?: React.ReactNode;
}
